module.exports = __webpack_public_path__ + "logo.c9daf007.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/logo.svg
 ** module id = 246
 ** module chunks = 0
 **/